import { object, string, number } from "yup"
import { ID2 } from "./yup.common"
export default object({
  borneBy: string().required().label("Bourne By"),
  contractId: ID2("Contract ID").required("Contract is required!"),
  expenseFor: ID2("Vehicle"),
  expenseTypeId: ID2("Expense Type").required("Please enter expense type!"),
  name: string(),
  netAmount: number().positive("Net Amount should be positive!"),
  quantity: number()
    .min(0, "Quantity should be minimum 0!")
    .typeError("Please enter valid quantity")
    .required("Quantity is required!"),
  quantityRate: number()
    .min(0, "Quantity rate should be minimum 0!")
    .required("Quantity rate is required!"),
  remark: string(),
  resourceUsed: number()
    .min(0, "Resource used should be minimum 0")
    .typeError("Please Enter valid number of resource used!"),
})
